module.exports = __webpack_public_path__ + "img/food-8.9603408c.jpg";